module.exports = __webpack_public_path__ + "img/huihui_03.fd67c51e.png";